import { render, staticRenderFns } from "./ProjectLockedNotice.vue?vue&type=template&id=306f3d62&"
import script from "./ProjectLockedNotice.vue?vue&type=script&lang=js&"
export * from "./ProjectLockedNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports